module.exports = __webpack_public_path__ + "static/media/9.0468a39c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flight/landing/reviews/9.png
// module id = 1729
// module chunks = 0